import { Component } from '@angular/core';
import {AlertComponent } from './alert.component';
import { AlertsService } from './alerts.service';
import { AlertsConfig } from '../../../config/alerts.config';

@Component({
  selector: 'app-success',
  templateUrl: './alert.component.html'
})
export class SuccessComponent extends AlertComponent {
  className = 'alert-success';
  timeout: number;

  constructor(
    protected service: AlertsService,
    config: AlertsConfig
  ) {
    super(service);
    this.timeout = config.successTimeout;
  }

  get message() {
    return this.service.success;
  }

  show(): void {
    super.show();
    setTimeout(() => this.hide(), this.timeout);
  }
}
